import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {apiPut} from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {Tooltip} from "@mui/material";
import {East} from "@mui/icons-material";
import {getSelectedLeague} from "../../redux/actions/smp-action/get-selected-league";
import {getLatestLeagueSMP} from "../../redux/actions/smp-action/smp-league-list";

export function ManualDeclareWinner(props) {
    const dispatch = useDispatch();
    const {round, item, value, roundsList} = props;
    const {league_id, _id} = round;

    const [isOpenPopover, setIsOpenPopover] = useState(false);
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);

    const [userId, setUserId] = useState(null);
    const [group1Player, setGroup1Player] = useState({
        user_id: null,
        name: null,
        mp_score: [],
    });
    const [group2Player, setGroup2Player] = useState({
        user_id: null,
        name: null,
        mp_score: [],
    });
    const [payload, setPayload] = useState(null);
    const [buildPayload, setBuildPayload] = useState(false);
    const [bye, setBye] = useState(false);
    const [winner, setWinner] = useState('');

    useEffect(() => {
        if (value != null && value[0]) {
            const {user_id} = value[0];
            setUserId(user_id);
        }

        if (item) {
            if (item.group1) {
                setGroup1Player(item.group1[0]);
            }
            if (item.group2) {
                setGroup2Player(item.group2[0]);
            }
        }

        if (buildPayload === true) {
            const {user_id: group1_user_id} = group1Player;
            const {user_id: group2_user_id} = group2Player;

            if (userId === group1_user_id) {
                setBye("group2");
                if (isFinalRound()) setWinner('group1');
                setGroup2Player(prevState => ({
                    ...prevState,
                    name: 'BYE'
                }));
            } else if (userId === group2_user_id) {
                setBye("group1");
                if (isFinalRound()) setWinner('group2');
                setGroup1Player(prevState => ({
                    ...prevState,
                    name: 'BYE'
                }));
            }
        }
    }, [buildPayload]);

    useEffect(() => {
        const myPayload = {
            match_id: item._id,
            round_id: _id,
            league_id: league_id,
            groupsdata: {
                is_bye: bye,
                match_status_track: [],
                group1: [
                    {
                        user_id: group1Player?.user_id,
                        name: group1Player?.name,
                        mp_score: [],
                    }
                ],
                group2: [
                    {
                        user_id: group2Player?.user_id,
                        name: group2Player?.name,
                        mp_score: [],
                    }
                ],
            },
        }

        if (isFinalRound()) {
            myPayload.groupsdata = {
                ...myPayload.groupsdata,
                won: winner
            }
        }

        setPayload(myPayload);
    }, [group1Player, group2Player, bye])

    useEffect(() => {

        if (payload !== null && buildPayload === true) {
            const url = `${ApiEndpoints.league.base}${ApiEndpoints.league.smpScoreManualBye}`;
            onPopoverHide();
            apiPut(url,
                payload,
                (response) => {
                    dispatch(getSelectedLeague(league_id));
                    dispatch(getLatestLeagueSMP());
                },
                (error) => {
                    console.log(error);
                });
            setPayload(null);
        }
    }, [payload])

    const isFinalRound = () => {
        return round.matches.length === 1;
    }

    const isBye = () => {
        switch (userId) {
            // IsBye Cases
            case group1Player?.user_id:
                return item.is_bye === 'group1';
            case group2Player?.user_id:
                return item?.is_bye === 'group2';
            default:
                return false
        }
    }

    const isWon = () => {
        switch (userId) {
            // IsBye Cases
            case group1Player?.user_id:
                /*
                * if user has id in group one then check
                * then check if is_bye is 'group2'
                * because group1 user won in BYE
                * */
                return item.is_bye === 'group2';
            case group2Player?.user_id:
                /*
                * if user has id in group one then check
                * then check if is_bye is 'group1'
                * because group2 user won in BYE
                * */
                return item.is_bye === 'group1';
            default:
                return false
        }
    }

    const hasOpponent = () => {
        switch (userId) {
            // IsBye Cases
            case group1Player?.user_id:
                /*
                * if user has id in group one then check
                * then check if is_bye is 'group2'
                * because group1 user won in BYE
                * */
                return group2Player?.user_id != null;
            case group2Player?.user_id:
                /*
                * if user has id in group one then check
                * then check if is_bye is 'group1'
                * because group2 user won in BYE
                * */
                return group1Player?.user_id != null;
            default:
                return undefined;
        }
    }

    const isByeOrIsWon = () => {
        return isBye() || isWon();
    }

    const onWinnerDeclare = (event) => {
        event.preventDefault();
        if (!value || !hasOpponent()) return;
        setBuildPayload(true);
    }

    const onPopoverShow = (e) => {
        setIsOpenPopover(true);
        setPopoverAnchorEl(e.currentTarget);
    }

    const onPopoverHide = () => {
        setIsOpenPopover(false);
        setPopoverAnchorEl(null);
    }

    const ConfirmPopover = () => {
        return (
            <Popover
                open={isOpenPopover}
                anchorEl={popoverAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                id={'confirm-popover'}
                onClose={onPopoverHide}
            >
                <Box sx={{border: 0, p: 1, bgcolor: "background.paper"}}>
                    <Stack spacing={2} direction="row">
                        <Button
                            variant="contained"
                            color="success"
                            onClick={onWinnerDeclare}
                        >
                            Yes
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={onPopoverHide}
                        >
                            No
                        </Button>
                    </Stack>
                </Box>
            </Popover>
        );
    }

    return (
        (!value || !hasOpponent()) ? <></>
            :
            isByeOrIsWon() ?
                <></>
                :
                <>
                    <Tooltip title={'Declare Winner'}
                             placement={'right'}>
                        {/*<East onClick={(e) => onWinnerBtnClick(e)}/>*/}
                        <East aria-describedby={'confirm-popover'} onClick={(e) => onPopoverShow(e)}/>
                    </Tooltip>
                    <ConfirmPopover/>
                </>
    );
}